var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFillFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    stroke: "currentColor",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73047 14V9V14ZM3.73047 9V2.75V9ZM3.73047 9L5.27464 8.69119C6.30622 8.48488 7.37553 8.583 8.35228 8.97375C9.41078 9.39713 10.5757 9.47619 11.6817 9.19969L11.7443 9.18406C12.1106 9.0925 12.2843 8.67306 12.09 8.34931L11.1147 6.72363C10.9012 6.36789 10.7945 6.19003 10.7692 5.99657C10.7587 5.91587 10.7587 5.83413 10.7692 5.75343C10.7945 5.55997 10.9012 5.38211 11.1147 5.02638L11.9137 3.69458C12.1228 3.346 11.8062 2.91858 11.4118 3.01716C10.4813 3.24979 9.50116 3.18327 8.61059 2.82706L8.35228 2.72373C7.37553 2.33303 6.30622 2.23485 5.27464 2.44117L3.73047 2.75M3.73047 2.75V1.5V2.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M3.73047 14V9M3.73047 9V2.75M3.73047 9L5.27464 8.69119C6.30622 8.48488 7.37553 8.583 8.35228 8.97375C9.41078 9.39713 10.5757 9.47619 11.6817 9.19969L11.7443 9.18406C12.1106 9.0925 12.2843 8.67306 12.09 8.34931L11.1147 6.72363C10.9012 6.36789 10.7945 6.19003 10.7692 5.99657C10.7587 5.91587 10.7587 5.83413 10.7692 5.75343C10.7945 5.55997 10.9012 5.38211 11.1147 5.02638L11.9137 3.69458C12.1228 3.346 11.8062 2.91858 11.4118 3.01716C10.4813 3.24979 9.50116 3.18327 8.61059 2.82706L8.35228 2.72373C7.37553 2.33303 6.30622 2.23485 5.27464 2.44117L3.73047 2.75M3.73047 2.75V1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFillFlag);
export default __webpack_public_path__ + "static/media/icon-fill-flag.90167d14fa07b54d2a7716b075e311f0.svg";
export { ForwardRef as ReactComponent };